import StorehouseIngredient from '@/models/storehouseIngredient';
import StorehouseProduct from '@/models/storehouseProduct';
import Transaction from '@/models/transaction';

const transformStorehouse = (storehouse: any) => ({
  id: storehouse.id,
  name: storehouse.name,
  address: storehouse.address,
  products: storehouse.products.map(StorehouseProduct.createFromRequest),
  ingredients: storehouse.ingredients.map(StorehouseIngredient.createFromRequest)
});

export default () => {
  if (Array.isArray(window.axios.defaults.transformResponse)) {
    return window.axios.defaults.transformResponse.concat((storehouseProps: any) => {
      return {
        ingredients: storehouseProps.ingredients.map(StorehouseIngredient.createFromRequest),
        products: storehouseProps.products.map(StorehouseProduct.createFromRequest),
        storehouses: storehouseProps.storehouses.map(transformStorehouse),
        otherStorehouses: storehouseProps.otherStorehouses.map(transformStorehouse),
        transactions: storehouseProps.transactions.map((transactionProps: any) => {
          let isReceive = true;

          if (
            null !== transactionProps.storehouseTransport
            && storehouseProps.storehouses.some((storehouse: any) => storehouse.id === transactionProps.storehouseTransport.id)
          ) {
            [ transactionProps.storehouseReceive, transactionProps.storehouseTransport ] = [ transactionProps.storehouseTransport, transactionProps.storehouseReceive ];
            [ transactionProps.staffReceive, transactionProps.staffTransport ] = [ transactionProps.staffTransport, transactionProps.staffReceive ];

            isReceive = false;
          }

          return new Transaction(transactionProps, isReceive);
        })
      };
    });
  }
};
